import * as types from "./types";

export const actionChangeEvent = (eventName, params) => ({
    type: types.TYPE_CHANGE_EVENT, eventName, params
});
